import { createGenericFetchAction } from 'ContentData/helpers/reduxHelpers';
import * as salesforceClient from 'ContentData/api/Salesforce';
import { SALESFORCE_FETCH_CAMPAIGN, SALESFORCE_FETCH_CAMPAIGNS, SALESFORCE_FETCH_INTEGRATION_STATUS, SALESFORCE_CLEAR_CAMPAIGNS, SALESFORCE_SAVE_CAMPAIGN_CACHE } from 'ContentData/actions/ActionTypes';
import { getCampaignCache } from 'ContentData/selectors/salesforce';
const fetchCampaignAction = createGenericFetchAction(SALESFORCE_FETCH_CAMPAIGN, salesforceClient.fetchCampaign);
const fetchCampaignsAction = createGenericFetchAction(SALESFORCE_FETCH_CAMPAIGNS, salesforceClient.fetchCampaigns);
const fetchIntegrationStatusAction = createGenericFetchAction(SALESFORCE_FETCH_INTEGRATION_STATUS, salesforceClient.fetchIntegrationStatus);
export const fetchCampaign = id => {
  return fetchCampaignAction(id);
};
export const fetchCampaigns = query => {
  return fetchCampaignsAction(query);
};
export const fetchIntegrationStatus = (...rest) => {
  return fetchIntegrationStatusAction(rest);
};
export function clearCampaigns() {
  return {
    type: SALESFORCE_CLEAR_CAMPAIGNS
  };
}
export const saveCache = id => {
  return (dispatch, getState) => {
    const campaign = getCampaignCache(getState(), {
      id
    });
    dispatch({
      type: SALESFORCE_SAVE_CAMPAIGN_CACHE,
      campaign
    });
  };
};